// LandingPage.jsx - Mobile-first, desktop-second landing page
// Single page with responsive CSS breakpoints

import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import CapabilityCards from './components/CapabilityCards';
import WorkflowShowcase from './components/WorkflowShowcase';
import UpdatePromise from './components/UpdatePromise';
import TrendingStyles from './components/TrendingStyles';
import OutputWall from './components/OutputWall';
import FAQAccordion from './components/FAQAccordion';
import FinalCTA from './components/FinalCTA';
import Footer from '../homeScreen/components/Footer';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <main>
        <Hero />
        <CapabilityCards />
        <WorkflowShowcase />
        <UpdatePromise />
        <TrendingStyles />
        <OutputWall />
        <FAQAccordion />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
